import { InjectionToken, signal, WritableSignal } from '@angular/core';
import { URLS } from './urls';

export const PERMISSIONS = new InjectionToken<
  WritableSignal<Record<
    keyof URLS,
    { viewer: boolean; editing: boolean }
  > | null>
>('permissions', {
  factory: () =>
    signal<Record<keyof URLS, { viewer: boolean; editing: boolean }> | null>(
      null
    ),
});
